import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './MobileMenuItem.scss';

const BackButton = ({ label, onClick }) => (
  <div
    className={classNames(
      styles.mobileMenuItem,
      styles.mobileMenuItem__fullWidth,
      styles.mobileMenuItem__chevronLeft
    )}
  >
    <button onClick={onClick}>{label}</button>
  </div>
);

BackButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default BackButton;
